import { render, staticRenderFns } from "./DeparturesPagePraiana.vue?vue&type=template&id=d1dcdc3c&scoped=true&"
import script from "./DeparturesPagePraiana.vue?vue&type=script&lang=js&"
export * from "./DeparturesPagePraiana.vue?vue&type=script&lang=js&"
import style0 from "./DeparturesPagePraiana.vue?vue&type=style&index=0&id=d1dcdc3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1dcdc3c",
  null
  
)

export default component.exports